import { isCompleted } from 'fitbeat.gym-core';
import { IUserLeaderboardViewModel } from 'fitbeat.models';
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { ScrollView, StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import { Button, ButtonSize, ButtonTypes } from '../components';
import Theme from '../theme';
import { optOutOfLeaderboard as optOutOfLeaderboardAction } from '../Tracking/actions';
import { LeaderboardTile } from '../Tracking/components/LeaderboardTile';
import { LeaderboardOptOutModal } from './LeaderboardOptOutModal';

interface IProps {
  t: (key: string, options?: any) => string;
  navigation: any;
  optOutOfLeaderboard: (leaderboard: IUserLeaderboardViewModel) => void;
}

class LeaderboardStatsScreen extends Component<IProps> {
  public render() {
    const { t, navigation, optOutOfLeaderboard } = this.props;
    const { leaderboard }: { leaderboard: IUserLeaderboardViewModel } = navigation.state.params;
    const shouldShowOptOutButton = !leaderboard.requireOptIn && !isCompleted(new Date(leaderboard.endDate));
    return (
      <ScrollView contentContainerStyle={styles.scrollViewContainer}>
        <LeaderboardOptOutModal navigation={navigation} isOpenedFromDashboard={false} />
        <View style={styles.container}>
          <View>
            <LeaderboardTile
              onTeamPress={
              leaderboard.competitionType === 'inter-team'
                ? (team: string) => navigation.navigate('LeaderboardTeam', { leaderboard, team })
                : undefined
              }
              leaderboard={leaderboard}
              t={t}
              navigation={navigation}
              summary={false}
              isFeatured={false}
              showRankings
              showJoinLeaderboardTile={false}
            />
          </View>
          {shouldShowOptOutButton && (
            <View style={{ backgroundColor: Theme.WHITE }}>
              <Button
                title={t('Opt out of leaderboard')}
                buttonType={ButtonTypes.TRANSPARENT}
                size={ButtonSize.MEDIUM}
                onPress={() => optOutOfLeaderboard(leaderboard)}
              />
            </View>
          )}
        </View>
      </ScrollView>
    );
  }
}

const styles = StyleSheet.create({
  scrollViewContainer: {
    flexGrow: 1,
  },
  container: {
    justifyContent: 'space-between',
    flex: 1,
  },
});

const mapDispatchToProps = (dispatch) => ({
  optOutOfLeaderboard: (leaderboard: IUserLeaderboardViewModel) => dispatch(optOutOfLeaderboardAction(leaderboard)),
});

export default
translate(['tracking, dashboard'], { wait: true })(connect(undefined, mapDispatchToProps)(LeaderboardStatsScreen));
